<template>
  <v-footer
    padless
    color="transparent"
    style="z-index: 4;"
  >
    <v-col
      class="text-center"
      cols="12"
    >
      <!-- back button -->
      <v-btn
        depressed
        rounded
        light
        color="secondary darken-3"
        class="mx-3"
        @click="$router.go(-1)"
      >
        Back
      </v-btn>
      
      <!-- next button -->
      <v-btn
        depressed
        rounded
        color="primary"
        class="mx-3"
      >
        Next
      </v-btn>
    </v-col>
  </v-footer>
</template>

<script>
  export default {
    name: 'CaseDetailFooter'
  }
</script>

<style lang="scss" scoped>

</style>